<template>
    <van-popup v-model="isShow" :closeable="false" get-container="body" :close-on-click-overlay="false">
        <div class="confirm-agreement">
            <van-icon class="close-icon" @click="onClose" name="cross" />
            <div class="agreement-content">
                <iframe :src="url"></iframe>
            </div>
        </div>
    </van-popup>
</template>
<script>
export default {
    props: ['url', 'isShow'],
    methods: {
        onClose() {
            this.$emit('onClose')
        },
    },
}
</script>
<style lang="scss" scoped>
.confirm-agreement {
    width: 800px;
    height: 600px;
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    .close-icon {
        position: absolute;
        padding: 14px;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 18px;
    }
    .agreement-content {
        width: 100%;
        height: 520px;
        overflow: scroll;
        padding: 20px 0;
        iframe {
            width: 100%;
            margin: 0 auto;
            display: block;
            height: 100%;
        }
    }
}
</style>
